import { defineComponent as _defineComponent } from 'vue'
import { computed, onBeforeUnmount, ref } from 'vue'
import TrellisModal from '@/components/TrellisModal.vue'
import { visible, recording, recorderRef, resolver, rejecter } from './media-recorder'
import { v4 as uuidv4 } from 'uuid'
import { formatDuration } from '@/filters/format-duration'
import singleton from '@/static/singleton'


export default /*#__PURE__*/_defineComponent({
  __name: 'MediaAudioRecorder',
  setup(__props) {

let media: Media
const mediaSrc = ref('')
const elapsed = ref(0)
const status = ref('stopped')
let intervalId: number
const amplitudeWindowSize = 5
const updateInterval = 100
const width = 400
const height = 200
const barWidth = 5
const amplitudes = new Uint8Array((width / barWidth) + 1)

function cleanup () {
  clearInterval(intervalId)
  console.log('cleaning up MediaAudioRecorder')
  if (media) {
    if (status.value !== 'stopped') {
      media.stopRecord()
    }
    media.release()
    media = null
  }
}

function reject (err) {
  cleanup()
  if (rejecter.value) {
    rejecter.value(err)
  }
}

function resolve () {
  console.log('resolving', mediaSrc.value)
  cleanup()
  if (resolver.value) {
    resolver.value(mediaSrc.value)
  }
}

function stopRecording () {
  if (media) {
    media.stopRecord()
  }
}

let updateCount = 0
let ampSum = 0
let startTime = 0
function update () {
  if (!media) return
  media.getCurrentAmplitude(amp => {
    ampSum += amp
    updateCount++
    if (updateCount % amplitudeWindowSize === 0) {
      amplitudes.copyWithin(0, 1)
      amplitudes[amplitudes.length - 1] = Math.round(255 * (ampSum / amplitudeWindowSize))
      ampSum = 0
    }
    if (status.value === 'running') {
      elapsed.value = Date.now() - startTime
    }
  }, err => {
    console.error(err)
  })
}

async function startRecording () {
  amplitudes.fill(0)
  ampSum = 0
  elapsed.value = 0
  mediaSrc.value = `cdvfile://localhost/temporary/recording-${uuidv4()}.mp3`
  media = new Media(mediaSrc.value, resolve, reject, s => {
    switch (s) {
      case Media.MEDIA_STARTING:
        status.value = 'starting'
        break
      case Media.MEDIA_RUNNING:
        status.value = 'running'
        startTime = Date.now()
        break
      case Media.MEDIA_STOPPED:
        status.value = 'stopped'
        break
      case Media.MEDIA_PAUSED:
        status.value = 'paused'
        break
    }
  })

  setInterval(update, updateInterval)

  media.startRecord()
}

async function onClose () {
  cleanup()
  visible.value = false
}

onBeforeUnmount(onClose)

const formattedElapsed = computed(() => {
  return formatDuration(elapsed.value)
})

const barColor = computed(() => {
  return singleton.darkTheme ? 'white' : 'black'
})

return { __sfc: true,media, mediaSrc, elapsed, status, intervalId, amplitudeWindowSize, updateInterval, width, height, barWidth, amplitudes, cleanup, reject, resolve, stopRecording, updateCount, ampSum, startTime, update, startRecording, onClose, formattedElapsed, barColor, TrellisModal, visible, recording, recorderRef }
}

})